import React, { FC } from 'react'
import {
    StyledOnAirContainer,
    StyledOnAir,
    StyledEqualiser,
} from './OnAirNotice.styled'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { TheWestLiveState } from '@news-mono/web-common'

export interface OnAirNoticeProps {
    className?: string
    showOnAirIconOnMobile?: boolean
}

export const OnAirNotice: FC<OnAirNoticeProps> = ({
    className,
    showOnAirIconOnMobile,
}) => {
    const isVRTest = process.env.NODE_ENV === 'vr_test'
    const { broadcast } = useSelector<AppState, TheWestLiveState>(
        (state) => state.theWestLive,
    )

    return (
        <StyledOnAirContainer>
            <StyledOnAir
                showOnAirIconOnMobile={showOnAirIconOnMobile}
                className={className}
            >
                {broadcast === 'catchup' ? 'Catch-up' : 'Live'}
            </StyledOnAir>
            <StyledEqualiser
                maxWaveHeight={16}
                widthInBars={3}
                volume={isVRTest ? 0 : 1}
                skewed={true}
            />
        </StyledOnAirContainer>
    )
}
